import React, { useState, useContext, useEffect } from 'react';
import { Col, FormControl, Modal } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardSubhead,
} from '@/shared/components/Card';
import { Button, ButtonGroup } from '@/shared/components/Button';
import {
  DropdownMenu, Dropdown, DropdownItem, DropdownToggle,
} from '@/shared/components/Dropdown';
import toast from 'react-hot-toast';
import { FaArrowDownShortWide, FaArrowUpWideShort } from 'react-icons/fa6';
import { Table } from '@/shared/components/TableElements';
import Pagination from 'react-bootstrap/Pagination';
import { he } from 'date-fns/locale';
import { border } from 'polished';
import AddUser from './AddUsers';
import EditUser from './EditUser';
import { AuthContext } from '../../../../../context/AuthContext';
import { ThemeContext } from '../../../../../context/ThemeContext';
import DeleteModal from './DeleteModal';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';
import mySimpleCrypt from '../../../Utils/DecryptData';

const ResponsiveTable = () => {
  const {
 userid, apiGlobal, setUsername, countryid, 
} = useContext(AuthContext);
  const { currentTheme } = useContext(ThemeContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext); 

  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [holdIDforDelete, setHoldIDforDelete] = useState('');
  const [userDataForEdit, setUserDataForEdit] = useState({});

  
    // Sorting state
    // const [sortable, setSortable] = useState({
    //   column: null, // which column is being sorted
    //   direction: 'asc', // 'asc' or 'desc'
    // });
    const [sortOrder, setSortOrder] = useState('asc');
    const [sortColumn, setSortColumn] = useState('name'); // This will track the column being sorted  

   // Pagination state
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 10;
 
   // Handle page change
   const handlePageChange = (pageNumber) => {
     setCurrentPage(pageNumber);
   };
 
   // Pagination Logic - Slice data for the current page
   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 
   // Use filteragent for pagination, not agent
   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
 
   // Total pages should be based on filteragent length, not agent
   const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const fetchUserData = async () => {
    const formData = new FormData();
    formData.append('user_id', userid);
    formData.append('country_id', countryid);
    try {
      const response = await fetch(`${apiGlobal}/user_admin_data.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        // console.log(data.data);
        setUserData(data.data);
        setFilteredData(data.data);
      } else {
        setUserData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [userid, sideBarRefresh?.adminUsersRefresh]);

  // // Handle sorting logic
  // const handleSort = (column) => {
  //   const direction = sortable.direction === 'asc' ? 'desc' : 'asc';
  //   const sortedData = [...filteredData].sort((a, b) => {
  //     if (column === 'srno') {
  //       return direction === 'asc' ? a.id - b.id : b.id - a.id;
  //     } if (column === 'name') {
  //       return direction === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
  //     } if (column === 'username') {
  //       return direction === 'asc' ? a.username.localeCompare(b.username) : b.username.localeCompare(a.username);
  //     } if (column === 'status') {
  //       return direction === 'asc' ? a.status - b.status : b.status - a.status;
  //     }
  //     return 0;
  //   });

  //   setSortable({ column, direction });
  //   setFilteredData(sortedData);
  // };
 
  
  const handleSort = (column) => {
    const newSortOrder = sortColumn === column 
    && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column
    
    const sortedData = [...filteredData].sort((a, b) => {
      if (column === 'name') {
        return newSortOrder === 'asc'
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      } if (column === 'username') {
        return newSortOrder === 'asc'
          ? a.username.localeCompare(b.username)
          : b.username.localeCompare(a.username);
      } if (column === 'status') {
        return newSortOrder === 'asc' ? a.status - b.status : b.status - a.status;
      }
      return 0;
    });
  
    setFilteredData(sortedData);
    setSortOrder(newSortOrder);
    setSortColumn(column); // Update the current sorted column
  };
  

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    setFilteredData(
      userData.filter(user => user.name.toLowerCase().includes(query) 
      || user.username.toLowerCase().includes(query)),
    );
  }, [searchQuery, userData]);

  const handleStatusToggle = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === '1' ? '0' : '1';

      const formData = new FormData();
      formData.append('id', userId);
      formData.append('restaurant_id', userid);
      formData.append('status', newStatus);
      formData.append('country_id', countryid);
      const response = await fetch(
        `${apiGlobal}/user_admin_status.php`, {
          method: 'POST',
          body: formData,
        },
      );
      const data = await response.json();
      if (data.status) {
        toast.success('Status Changed.');
        fetchUserData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error toggling status:', error);
    }
  };

  const handleAddUser = async (user) => {
    // console.log(JSON.stringify(user, null, 2));
     if (!user.countryCode) {
      toast.error('Please select a country code');
      return;
    }
    try {
      const formData = new FormData();
      Object.entries(user).forEach(([key, value]) => formData.append(key, value));
      formData.append('country_code', user.countryCode?.value);

      const response = await fetch(`${apiGlobal}/user_admin_add.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        toast.success('User added successfully');
        setShowModal(false);
        fetchUserData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };

  // eslint-disable-next-line
  const handleEditUser = (id, name, username, countryCode, country_code_id, designation, password, mobile1, mobile2) => {
    setShowModalEdit(true);
    setUserDataForEdit({
      // eslint-disable-next-line
      id, name, username, countryCode, country_code_id, designation, password, mobile1, mobile2,
    });
  };
    const setUsernameiduserEdit = () => {
    const { name } = userData.find(u => u.id === '1');
    // console.log(name);
      setUsername(name); 
  };

  const editUserHandler = async (values) => {
    // console.log(JSON.stringify(values, null, 2));

    try {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => formData.append(key, value));
       formData.append('country_code', values.country_code_id);
      const url = await fetch(`${apiGlobal}/user_admin_edit.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Record updated successfully.') {
        toast.success('User updated successfully.');
        setShowModalEdit(false);
        fetchUserData();
        setUsernameiduserEdit();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error updating user:', error);
    } 
  };




  const handleDeleteModal = (id) => {
    setdeleteModalShow(true);
    setHoldIDforDelete(id);
  };

  const handleDeleteUser = async () => {
    const formData = new FormData();
    formData.append('id', holdIDforDelete);
    formData.append('country_id', countryid);
    try {
      const url = await fetch(`${apiGlobal}/user_admin_delete.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Data deleted successfully') {
        toast.success('User deleted successfully');
        setdeleteModalShow(false);
        setHoldIDforDelete('');
        fetchUserData();
    } else {
      toast.error(data.message);
    }
  } catch (error) {
    console.error('Error deleting user:', error);
  }
};

  const renderTableRows = () => (
    currentItems.map((user, index) => (
      <tr
        key={user.id}
        style={{
        // backgroundColor: user.status === '1' ? '#D4F1F4' : '#FCE4EC', 
        // // Light cyan for active, soft pink for inactive
        // color: user.status === '1' ? '#0F4C5C' : '#880E4F', // Darker shades for contrast
        fontWeight: 'bold',
        transition: 'background-color 0.3s ease-in-out',
      }}
      >
        <td>{index + 1}</td>
        <td>{user.name}</td>
        <td>{user.username}</td>
        <td>
          {user.status === '1' ? (
            <span className="bg-success text-white p-1 rounded">
              <i className="lnr lnr-checkmark-circle" /> Approved
            </span>
          ) : (
            <span className="bg-danger text-white p-1 rounded">
              <i className="lnr lnr-cross-circle" /> Not Approved
            </span>
          )}
        </td>
        <td>
          {user.id !== '1' && (
            <Dropdown dir="ltr">
              <DropdownToggle 
                variant="outline-primary"
                size="sm"
                style={{
                   height: '30px',
                   borderRadius: '25px',
              }}
              >
                Actions
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleStatusToggle(user.id, user.status)}>
                  {user.status === '1' ? 'Mark as Not Approved' : 'Mark as Approved'}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
        </td>
        <td>
          <Button
            variant="success"
            title="Edit"
            onClick={() => handleEditUser(
              user.id,
              user.name,
              user.username,
              user?.country_code,
              user?.country_code_id,
              user.designation,
              user.password,
              user.mobile1,
              user.mobile2,
              )}
            size="sm"
          >
            <span className="lnr lnr-pencil" />
          </Button>
          {user.id !== '1' && (
            <Button 
              variant="danger" 
              title="Delete"
              onClick={() => handleDeleteModal(user.id)}
              size="sm"
            >
              <span className="lnr lnr-trash" />
            </Button>
          )}
        </td>
      </tr>
    ))
  );

  if (isLoading) return <div>Loading...</div>;

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardSubhead>
              <Button
                style={{ float: 'right' }}
                variant="primary"
                size="sm"
                onClick={() => setShowModal(true)}
              >
                Add User
              </Button>
            </CardSubhead>
            <div className="d-flex">
              <FormControl
                type="text"
                placeholder="Search by name or username"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                style={{
 width: '30%',
marginTop: '10px',
backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
                color: currentTheme === 'Dark' ? 'white' : 'black', 
}}
              />
              <Button
                variant="outline-danger"
                style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
                className="mt-3 mx-2"
                onClick={() => {
            fetchUserData();
            toast.success('Data refreshed successfully');
          }}
              >
                Refresh
              </Button>
            </div>
            
          </CardTitleWrap>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>
                  Sr no. 
                </th>

                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  Name {sortColumn === 'name' 
                  && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
                </th>

                <th onClick={() => handleSort('username')} style={{ cursor: 'pointer' }}>
                  Username {sortColumn === 'username' 
                  && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
                </th>

                <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
                  Status {sortColumn === 'status' 
                  && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
                </th>
                <th>Action </th>
                <th>Edit/Delete</th>
              </tr>
            </thead>
            <tbody>{renderTableRows()}</tbody>
          </Table>
          {/* Pagination Controls */}
          <div
            style={{
          // position: 'fixed', 
          marginTop: '12px',
          bottom: '20px', 
          right: '20px', 
          zIndex: 999, 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
        }}
          >
            <Pagination>
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {Array.from({ length: totalPages }, (_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
          ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </CardBody>

        {/* Add User Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
          <Modal.Header
            style={{
      backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
      color: currentTheme === 'Dark' ? 'white' : 'black',
    }}
            closeButton
            closeVariant={currentTheme === 'Dark' && 'white'}
          >
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{
      backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
      color: currentTheme === 'Dark' ? 'white' : 'black',
    }}
          >
            <AddUser onSubmit={handleAddUser} />
          </Modal.Body>
        </Modal>
          
        {/* Edit User Modal */}
        <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered size="xl">
          <Modal.Header
            style={{
      backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
      color: currentTheme === 'Dark' ? 'white' : 'black',
    }}
            closeButton
            closeVariant={currentTheme === 'Dark' && 'white'}
          >
            <Modal.Title>Edit User</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{
      backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
      color: currentTheme === 'Dark' ? 'white' : 'black',
    }}
          >
            <EditUser userDetails={userDataForEdit} onSubmit={editUserHandler} />
          </Modal.Body>
        </Modal>

        {/* Delete User Modal */}
        <DeleteModal
          show={deleteModalShow}
          handleClose={() => setdeleteModalShow(false)}
          handleDelete={handleDeleteUser}
          message="Are you sure you want to delete this User?"
        />
      </Card>
    </Col>
  );
};

export default ResponsiveTable;


// import React, { useState, useContext, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import Badge from '@/shared/components/Badge';
// import { Col } from 'react-bootstrap';
// import {
//   Card, CardBody, CardTitleWrap, CardTitle, CardSubhead,
// } from '@/shared/components/Card';
// import { Button, ButtonToolbar } from '@/shared/components/Button';
// import {
//     DropdownMenu, Dropdown, DropdownItem, DropdownDivider, DropdownToggle,
//   } from '@/shared/components/Dropdown';
//   import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
// import { Table } from '@/shared/components/TableElements';
// import { AuthContext } from '../../../../../context/AuthContext';
// import { GlobalVarContext } from '../../../../../context/GlobalVarContext';



// const ResponsiveTable = () => {
//     const { apiGlobal } = useContext(GlobalVarContext);
//     const { userid } = useContext(AuthContext);
//   const [userData, setuserdata] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [status, setStatus] = useState('1');

//   const fetchUserData = async (id) => {
//    try {
//        const url = await fetch(`${apiGlobal}/restaurant/user_restaurant_data.php?restaurant_id=${id}`);
//        const data = await url.json();
//       if (data.status && data.message === 'Success') {
//         setuserdata(data.data);
//         setIsLoading(false);
//       } else {
//         setuserdata([]);
//       }
//    } catch (error) {
//       console.error(error.message);
//    }
//   };

//   useEffect(() => {
//     fetchUserData(userid);
//   }, [userid]);

//   if (isLoading) {
//     return <div>Loading...</div>;
//   }
 
//   const statusHandler = (statuscode) => {
//    if (statuscode === '1') {
//     setStatus('0');
//    } 
//    if (statuscode === '0') {
//     setStatus('1');
//    }
//   };

//   return (
//     <Col md={12} lg={12}>
//       <Card>
//         <CardBody>
//           <CardTitleWrap>
//             <CardSubhead>All Users{' '}<span className="red-text">BitWize-Restaurant</span></CardSubhead>
//           </CardTitleWrap>
//           <Table responsive bordered>
//             <thead style={{ marginTop: '20px' }}>
//               <tr>
//                 <th>Sr no.</th>
//                 <th>Name</th>
//                 <th>Username</th>
//                 <th>Status</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>

//               {userData.map((user, index) => (
//                 <tr key={user.id}>
//                   <td>{index + 1}</td>
//                   <td>{user.name}</td>
//                   <td>{user.username}</td>
//                   <td>
//                     <Dropdown className="btn-group" dir="ltr">
//                       <Button variant="outline-primary" size="sm">
//                         {status === '1' ? 'Approved' : 'Not Approved'}
//                       </Button>
//                       <DropdownToggle variant="outline-primary" size="sm">
//                         <ChevronDownIcon />
//                       </DropdownToggle>
//                       <DropdownMenu>
//                         <Button 
//                           variant="outline-primary" 
//                           size="sm"
//                           onClick={statusHandler(status, user.id)}
//                         >
//                           {status === '1' ? 'Not Approved' : 'Approved'}
//                         </Button>
//                       </DropdownMenu>
//                     </Dropdown>

//                   </td>
//                 </tr>
//                     ))}
              
            
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </Col>
//   );
// };

